var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",style:({
    transform: `scale(${_vm.zoom})`,
    transformOrigin: '0 0',
    width: `${_vm.initWidth}px`,
    'min-height': `${_vm.initHeight}px`,
    'max-height': `${_vm.initHeight}px`,
  })},[_c('div',{staticClass:"appTitle"},[_vm._v(" "+_vm._s(_vm.cityDetail.cityName + (_vm.cityDetail.homeTitle ? _vm.cityDetail.homeTitle : "农村集体财产监督管理平台"))+" ")]),_c('div',{staticClass:"back",on:{"click":_vm.backHome}},[_c('img',{attrs:{"src":require("@/assets/bigData/home.png"),"alt":""}}),_c('span',[_vm._v("返回首页")])]),_c('Map',{staticClass:"map",attrs:{"formDetail":_vm.form,"level":_vm.level},on:{"mapClickMethod":_vm.mapClickMethod}}),_c('transition',{attrs:{"name":"el-zoom-in-center"}},[_c('bigDataHuojia',{ref:"cqjy1",staticClass:"child1",attrs:{"formDetail":_vm.form}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }